import { Container, Row, Col} from "react-bootstrap";

function Impressum () {
    const MyStyle1 =  {
          color: "black",
          fontSize: "3.2vmin"        
      }

    return (
         <Container fluid style={{height: "100vh", backgroundColor: "#f4f6f7"}}>
            <Row>
                <Col style={{textAlign: "Center"}}>
                    <div>
                        <br/>
                        <h1>Impressum</h1>
                        <br/>
                        <br/>
                        
                    </div>
                    <div style={MyStyle1}>
                        <p>Angaben gemäß § 5 DDG</p><br/>
                        <strong>Verantwortlich für den Inhalt: </strong><br/>
                        <p>Rainer Senft<br/>
                            Waldstraße 15<br/> 
                            79379 Müllheim i. M. <br/> 
                        </p>                        
                        <br/>
                        <p>
                            <strong>Kontakt:</strong><br/>
                            Telefon: +491606403151<br/>
                            E-Mail: <a href="mailto:messagebox@raliwa.de?subject=Anfrage MessageBox">info@raliwa.de</a><br/>
                        </p>                         
                    </div>                    
                </Col>
            </Row>
        </Container>
    )
}

export default Impressum;